import { render, staticRenderFns } from "./TeklifOnayMailButton.vue?vue&type=template&id=499889a8&"
import script from "./TeklifOnayMailButton.vue?vue&type=script&lang=js&"
export * from "./TeklifOnayMailButton.vue?vue&type=script&lang=js&"
import style0 from "./TeklifOnayMailButton.vue?vue&type=style&index=0&id=499889a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports